const lsg_slidecart = { 
    
    init: () => {
      

        /**
         * TODO:
         *   - Completely remove dependency on JQuery
         *   - Possibly separate some processes to be called independently
         *     -> Currently, render process is one long chain for every cart update.
         *        Could save on unnecessary API calls in certain cases.
         *        For instance, upsells are pulled afresh every time the cart is
         *        re-rendered. Doesn't make sense for merely increasing quantity
         *        of existing products w/ none added/removed. Also causes a significant
         *        layout jump when upsells disappear/reappear.
         *   - Improve/refine Theme Editor support
         *   - General restructure/consolidation/clean-up
         */
      
        // Elements
        const openBtn           = document.querySelector('[lsg-slidecart-open]'),
              closeBtn          = document.querySelectorAll('[lsg-slidecart-close]'),
              upsellWrapper     = document.querySelector('.lsg-slidecart__upsell-wrapper');
              upsellModule      = document.querySelector('[lsg-slidecart-upsell-list]'),
              upsellSlider      = document.querySelector('[lsg-slidecart-upsell-slider]'),
              productForm       = document.getElementById('AddToCartForm');

        // Main Slidecart opening process
        function slideCartOpen() {
            renderCart();
        }

        // Open the Slidecart accessible externally in the window
        window.LSG_OPEN_CART = function LSG_OPEN_CART() {
            slideCartOpen();
        }

        // Ask the Slidecart to re-render itself
        window.LSG_CART_UPDATE = function LSG_CART_UPDATE() {
            renderCart();
        }

        // Open slidecart if #cart present in window location
        // Used with redirect from /cart to /#cart to obfuscate cart template
        if (window.location.href.indexOf("#cart") > -1) {
            slideCartOpen();
        }

        // Close the Slidecart
        function slideCartClose() {
            $('body').css('overflow-y','scroll');
            $(`.lsg-slidecart`).removeClass('active');
            $(`[lsg-slidecart-overlay]`).removeClass('active');
        }

        // Event listeners
        openBtn.addEventListener('click', (e) => {
            e.preventDefault();
            slideCartOpen();
        });

        closeBtn.forEach(el => {
            el.addEventListener('click', (e) => {
                slideCartClose();
            })
        });

        // Take over processing of ATC from standard Shopify product forms
        if (productForm)
        {
            productForm.addEventListener('submit', (e) => {
                e.preventDefault();
                let data = new FormData(e.target);
                $.ajax({
                    type: "POST",
                    url: window.Shopify.routes.root + 'cart/add.js',
                    data: data,
                    processData: false,
                    contentType: false,
                    success: function(response) {
                        slideCartOpen();
                    },
                    error: function(errResponse) {
                        console.log(errResponse);
                    }
                });
            });
        }
        
        // Reset Slidecart
        function clearCartDrawer() {
            $(`[lsg-slidecart-product-wrapper]`).html('');
            upsellWrapper.style.display = 'none';
        }

        // Cart rendering processes
        function renderCart() {
            $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: function(cart) {
                    clearCartDrawer();

                    $(`[shipping-bar-percent]`).css('max-width', '0%');
                    const freeShipText = $(`[slidecart-shipping-bar]`).attr('free-shipping-success-text');
                    const freeShipping = parseInt($(`[slidecart-shipping-bar]`).attr('free-shipping-threshold'));

                    var amountToShipping = (freeShipping-parseFloat(cart.items_subtotal_price/100).toFixed(2)).toFixed(2);

                    if (amountToShipping <= 0 ) {
                        $(`[shipping-bar-percent]`).css('max-width', '100%');
                        $(`[shipping-bar-text]`).text(freeShipText);
                    }
                    else if (parseInt(amountToShipping) == freeShipping) {
                        $('[lsg-slidecart-product-wrapper]').html('Your cart is empty');
                        $(`[shipping-bar-text]`).text(`You're $${amountToShipping} away from free shipping!`);
                    }
                    else {
                        var maxWidth = (parseFloat(cart.items_subtotal_price/100).toFixed(1)/parseInt(freeShipping))*100;
                        $(`[shipping-bar-percent]`).css('max-width', maxWidth+'%');
                        $(`[shipping-bar-text]`).text(`You're $${amountToShipping} away from free shipping!`);
                    }

                    const cartSubtotal = `$${parseFloat(cart.items_subtotal_price/100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1").toString()}`;
                    $(`[lsg-slidecart-subtotal-price]`).text(cartSubtotal);

                    cart.items.forEach(function(item, index) {
                
                        const productTitle      = `<h3>${item.product_title}</h3>`;
                        const productId         = item.id;
                        const productImage      = `<img src="${item.image + '&width=200'}" >`;

                        let options             = '';
                        item.variant_options.forEach(function(option, index){
                            if (typeof option == "undefined") { return; }
                            if (option == "Default Title") { return; }
                            options = `${options}<p>${option}</p>`
                        });

                        let sellingPlan         = '';  
                        if (JSON.stringify(item.selling_plan_allocation) != null ) {
                            sellingPlan = `<p>${item.selling_plan_allocation.selling_plan.name}</p>`;
                        }

                        const productPrice      = `
                            <p>
                                $${parseFloat(item.line_price/100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1").toString()}
                            </p>
                        `;
                        const productQuantity   = item.quantity;
                        const itemKey           = item.key;

                        const concatProductInfo = `
                            <li
                                class="lsg-slidecart__item-wrapper"
                                data-slidecart-item="${productId}"
                                data-line="${Number(index + 1)}"
                                role="group"
                                aria-label="Product"
                            >
                                <div class="lsg-slidecart__item-image-wrapper">
                                    ${productImage}
                                </div>
                                <div class="lsg-slidecart__item-details-wrapper">

                                    <div class="lsg-slidecart__item-description-wrapper">
                                        ${productTitle}
                                        ${options}
                                        ${sellingPlan}
                                    </div>

                                    <div class="lsg-slidecart__item-controls">
                                        <button
                                            type="button"
                                            aria-label="Remove Item"
                                            lsg-slidecart-remove-item
                                            data-remove-key="${itemKey}"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><g id="close"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="currentColor"/></g></svg>
                                        </button>
                                    </div>

                                    <div class="lsg-slidecart__item-qty-wrapper">
                                        <div class="lsg-slidecart__item-qty-controls">
                                            <button
                                                type="button"
                                                aria-label="Decrease Quantity"
                                                class="qty-button js-minus-button"
                                                data-minus
                                                data-qty-button
                                                data-key="${itemKey}"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><rect x="5" y="46" width="90" height="8" fill="currentColor"/></g></svg>
                                            </button>
                                            <input
                                                class="js-cart-qty-input"
                                                type="number"
                                                pattern="[0-9]*"
                                                data-input-key="${itemKey}"
                                                value="${productQuantity}"
                                            />
                                            <button
                                                type="button"
                                                aria-label="Increase Quantity"
                                                class="qty-button js-plus-button"
                                                data-plus
                                                data-qty-button
                                                data-key="${itemKey}"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46" fill="currentColor"/></g></svg>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="lsg-slidecart__item-price">
                                        ${productPrice}
                                    </div>

                                </div>
                            </li>
                        `;
                        
                        $(`[lsg-slidecart-product-wrapper]`).html($(`[lsg-slidecart-product-wrapper]`).html() + concatProductInfo);
                        
                    });
                       
                    $(`[js-cart-qty-input]`).change(function() {
                        var newQty = parseInt($(this).attr('value'));
                        var key = $(this).attr('data-input-key');
                        var data = {
                            "id": key,
                            "quantity": newQty
                        };
                        $(this).attr('value', newQty);
                        $.ajax({
                            type: 'POST',
                            url: '/cart/change.js',
                            data: data,
                            dataType: 'json',
                            success: function() {
                                renderCart();
                            }
                        });
                    });

                    $(`[data-qty-button]`).click(function() {
                        var key = $(this).attr('data-key');
                        var currentQty = parseInt($(`[data-input-key="${key}"]`).attr('value'));
                        var newQty;
                        var data; 
                        if ($(this).hasClass('js-plus-button')) {
                            newQty = currentQty + 1;
                            data = {
                                "id": key,
                                "quantity": newQty
                            };
                        }
                        else {
                            newQty = currentQty - 1;
                            data = {
                                "id": key,
                                "quantity": newQty
                            };
                        }
                        $(`[data-input-key="${key}"]`).attr('value', newQty);
                        $.ajax({
                            type: 'POST',
                            url: '/cart/change.js',
                            data: data,
                            dataType: 'json',
                            success: function() {
                                renderCart();
                            }
                        });
                    });

                    $(`[lsg-slidecart-remove-item]`).on('click', function() {
                        var key = $(this).attr('data-remove-key');
                        var data = {
                            "id": key,
                            "quantity": 0
                        };
                        $.ajax({
                            type: 'POST',
                            url: '/cart/change.js',
                            data: data,
                            dataType: 'json',
                            success: function() {
                                renderCart();
                            }
                        });
                    });

                    // Open cart
                    $(`.lsg-slidecart`).addClass('active');
                    $(`[lsg-slidecart-overlay]`).addClass('active');
                    $('body').css('overflow-y','hidden');
        
                    if (upsellModule)
                    {
                        renderUpsells(cart);
                    }
                },
            });
        }

        function renderUpsells(cart) {
            $(`[lsg-slidecart-upsell-list]`).html('');

            let baseURL     = `${window.Shopify.routes.root}recommendations/products.json`;
            let limit       = 3; // Per product
            let intent      = upsellModule.getAttribute('data-recc-type'); // Optional, 'related' (default) or 'complementary'

            let tasksTotal  = cart.items.length;
            let tasksDone   = 0;

            const upsellItems = [];

            // Hit the recommendations API for each product in cart to compile a list
            cart.items.forEach(function(item, index) {
                let callURL = `${baseURL}?product_id=${item.product_id}&limit=${limit}&intent=${intent}`;
                $.ajax({
                    type: 'GET',
                    url: callURL,
                    dataType: 'json',
                    success: function(data) {
                        data.products.forEach(function(product, index) {
                            if (!product.available) { return; }
                            if (!product.variants[0].available) { return; }
                            let productData = {
                                "product_id"    : product.id,
                                "product_title" : product.title,
                                "product_img"   : product.featured_image,
                                "variant_id"    : product.variants[0].id,
                                "price"         : product.variants[0].price
                            };
                            upsellItems.push(productData);
                        });

                        tasksDone += 1;
                        if (tasksDone == tasksTotal) {
                            buildUpsells(upsellItems);
                        }
                    } 
                });
            });
        }

        function buildUpsells(data)
        {
            // Uniquify upsell products
            const items = [...new Map(data.map(v => [v.product_title, v])).values()];

            if (items.length > 1) {
                upsellWrapper.style.display = 'block';
            } else {
                upsellWrapper.style.display = 'none';
            }

            items.forEach(function(item, index) {
                let listItem = document.createElement('li');
                listItem.classList.add('lsg-slidecart__upsell-list-item');
                listItem.innerHTML = `
                    <div class="lsg-slidecart__upsell-inner-wrapper">
                        <div class="lsg-slidecart__upsell-details-wrapper">
                            <div class="lsg-slidecart__upsell-image-wrapper">
                                <img src="${item.product_img + '&width=200'}" alt="">
                            </div>
                            <div>
                                <h3 class="lsg-slidecart__upsell-title">${item.product_title}</h3>
                                <div class="lsg-slidecart__upsell-price">$${(item.price / 100).toFixed(2)}</div>
                            </div>
                        </div>
                        <button
                            class="lsg-slidecart__upsell-button"
                            lsg-slidecart-upsell-button
                            data-variant-id="${item.variant_id}"
                        >
                            + Add
                        </button>
                    </div>
                `
                upsellModule.append(listItem);
            });

            const upsellBtns = document.querySelectorAll('[lsg-slidecart-upsell-button]');
            upsellBtns.forEach(el => {
                el.addEventListener('click', (e) => {
                    const productData = {
                        items: [
                            {
                                id: parseInt(e.target.getAttribute('data-variant-id')),
                                quantity: 1
                            }
                        ]
                    };

                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(productData)
                    })
                    .then(response => response.json())
                    .then(data => {
                        if (data.status)
                        {
                            console.error(`${data.message}: Status ${data.status} - ${data.description}`);
                        }
                        else
                        {
                            renderCart();
                        }
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
                })
            });
        }

        // Simple slider implementation
        if (upsellSlider)
        {
            const slidesContainer       = upsellSlider.querySelector('.lsg-slidecart__upsell-list'),
                  prevBtn               = upsellSlider.querySelector('#slide-arrow-prev'),
                  nextBtn               = upsellSlider.querySelector('#slide-arrow-next');
            
            nextBtn.addEventListener("click", () => {
                let slide = upsellSlider.querySelector('.lsg-slidecart__upsell-list-item');
                const slideWidth = slide.clientWidth;
                slidesContainer.scrollLeft += slideWidth;
            });

            prevBtn.addEventListener("click", () => {
                let slide = upsellSlider.querySelector('.lsg-slidecart__upsell-list-item');
                const slideWidth = slide.clientWidth;
                slidesContainer.scrollLeft -= slideWidth;
            });
        }


        /**
         * Theme Editor Support
         */

        const parent = `.lsg-slidecart`;

        // Section loaded in Theme Editor
        document.addEventListener('shopify:section:select', function(event) {
            const $parent = $(event.target);
            let check = $parent.find(`${parent}`);
            if (check.length > 0) {
                slideCartOpen();
            }
        });

        document.addEventListener('shopify:section:deselect', function(event) {
            const $parent = $(event.target);
            let check = $parent.find(`${parent}`);
            if (check.length > 0) {
                slideCartClose();
            }
        });
  
        // Block selected in Theme Editor
        document.addEventListener('shopify:block:select', function(event) {
            const $block = $(event.target);
            const $parent = $block.parents(`${parent}`);
            if ($parent.length > 0) {
                // slideCartOpen();
            }
        });
  
        // Block deselected in Theme Editor
        document.addEventListener('shopify:block:deselect', function(event) {
            const $block = $(event.target);
            const $parent = $block.parents(`${parent}`);
            if ($parent.length > 0) {
                // slideCartClose();
            }
        });
        

    }
}
export default lsg_slidecart;